(function () {
    'use strict';
    angular.module('Services').service('AffiliateReferredClientsTableService', AffiliateReferredClientsTableService);
    AffiliateReferredClientsTableService.$inject = [
        '$filter',
        'toastr',
        '$rootScope',
        'TableLiteFactory',
        '$location',
        'AffiliateService',
        '$routeParams',
        'ClientService',
        '$q',
        'ConfirmationModalFactory'
    ];

    function AffiliateReferredClientsTableService(
        $filter,
        toastr,
        $rootScope,
        TableLiteFactory,
        $location,
        AffiliateService,
        $routeParams,
        ClientService,
        $q,
        ConfirmationModalFactory
    ) {
        return function () {
            const role = $rootScope.GlobalProfile.permissionGroup.roles.find(permission => permission.code === 'ROLE_COMPANY_ADMIN' || permission.code === 'ROLE_ADMIN') ? true : false;

            const unassignConfirmationModal = new ConfirmationModalFactory({}, {
                message: 'You are about to unassign promo for this referrer company.',
                code: 'messages.warning.deleteAdminAccount.CODE'
            });

            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtract: true,

                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-success',
                        label: 'Export',
                        tooltip: 'Export',
                        onClick: function () {
                            exportBtn($routeParams.id,);
                        }
                    }]
                },
                headers: [
                    {
                        label: 'Company Name',
                        viewName: 'companyName',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            items: [],
                            onSubmit: header => {
                                const filter = header.filter.model.name
                                tableActions.sendRequest({ companyName: filter })
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                ClientService.Company.getAll(
                                    res => {
                                        angular.forEach(res.content, (item) => {
                                            filterItems.push(item);
                                        });
                                        defer.resolve();
                                    },
                                    err => {
                                        defer.reject();
                                        toastr.error(err.message);
                                    },
                                    {
                                        name: model,
                                        size: 1000
                                    }
                                )


                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Promo Code',
                        viewName: 'code',
                        filterName: 'promoCode.code',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Commencement Date',
                        viewName: 'commencementDate',
                        filterName: 'commencementDate',
                        filter: {
                            type: 'datePicker',
                            placeholder: 'Search',
                            useArray: true,
                            onSubmit: header => {
                                const filter = angular.copy(header);
                                filter.filter.fromModel = $filter('bbaDate')(new Date(header.filter.fromModel));
                                filter.filter.toModel = $filter('bbaDate')(new Date(header.filter.toModel));
                                sendRequest(evaluateFilter(filter));
                                // const from = $filter('bbaDate')(new Date(header.filter.fromModel)) ;
                                // const to = $filter('bbaDate')(new Date(header.filter.toModel)) ;
                                // console.log(from,to)
                                // tableActions.sendRequest({commencementDate:from,commencementDate:to})
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Discount Condition',
                        viewName: 'conditions'
                    },
                    {
                        label: 'Discount Amount',
                        viewName: 'discountAmount',
                        filterName: 'promoCode.discountValue',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Discount Percent',
                        viewName: 'discountPercent',
                        filterName: 'promoCode.discountPercent',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Referrer',
                        viewName: 'referrer',
                        filterName: 'promoCode.userMarketing.firstName',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            items: [],
                            onSubmit: header => {
                                const filterfirst = header.filter.model.firstName
                                const filterlast = header.filter.model.lastName
                                tableActions.sendRequest({ 'promoCode.userMarketing.firstName': filterfirst, 'promoCode.userMarketing.lastName': filterlast })
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                AffiliateService.getUserMarketing(
                                    data => {
                                        angular.forEach(data.content, (item) => {
                                            const name = `${item.firstName} ${item.lastName}`
                                            filterItems.push({ viewName: name, firstName: item.firstName, lastName: item.lastName });
                                        });
                                        defer.resolve();

                                    }, err => {
                                        defer.reject();
                                    }, { size: 30, 'firstName': model, companyMarketingId: $routeParams.id }
                                )
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Action',
                        viewName: 'actions'
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getAllcompanyReferred,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        'promoCode.companyMarketing.id': $routeParams.id,
                        size: 20,
                        page: 0,
                        sort: 'commencementDate,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                console.log(data)
                angular.forEach(data.content, function (item) {
                    item.code = item.promoCode.code;
                    item.commencementDate = $filter('date')(new Date(item.commencementDate), "yyyy-MM-dd")
                    // const startDate = $filter('date')(new Date(item.startDate),  "yyyy/MM/dd");
                    // const endDate  = $filter('date')(new Date(item.endDate),  "yyyy/MM/dd");
                    // const durationStartDate = $filter('date')(new Date(item.durationStartDate),  "yyyy/MM/dd");
                    // const durationEndDate = $filter('date')(new Date(item.durationEndDate),  "yyyy/MM/dd");
                    item.discountAmount = `${item.promoCode.discountValue} ${item.promoCode.currency}`;
                    item.discountPercent = item.promoCode.discountPercent
                    item.referrer = `${item.companyName} `

                    item.conditions = item.promoCode.promoCondition
                    item.createdDate = $filter('date')(new Date(item.createdDate), "yyyy-MM-dd");
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View',
                            class: 'btn btn-success',
                            action: row => {
                                $location.path('/affiliates-sales/referred/' + item.companyId);
                            }
                        },{
                            text: 'Unassign',
                            class: 'btn btn-warning',
                            action: row => {
                                //    
                                unassignBtnAccountClicked(row)

                            }
                        }]
                    };
                    if (!role) {
                        item.actions.buttons.splice(1, 1)
                    }
                    tableData.data.push(item);
                });
            };


            function exportBtn() {
                AffiliateService.exportByCompany(null, res => {
                    toastr.success('File exported succesfully.')
                }, err => {
                    toastr.error(err.message)
                }, { company_marketing_id: $routeParams.id })


            };

            function unassignBtnAccountClicked(item) {
                unassignConfirmationModal.getInstance().result.then(function (cond) {
                    if (!cond) { return; }
                    unassignAccount(item)
                });
            }

            function unassignAccount(row) {
                AffiliateService.unassignedCompanyReferred(res => {
                    toastr.success('Success')
                    sendRequest()
                },
                    err => {
                        console.log(err)
                    }, row.companyId)
            }

            this.tableData = tableData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/AffiliateReferredClientsTableService.js